"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexOf = exports.find = void 0;
function find(elements, needValue, needKey) {
    return indexOf(elements, needValue, needKey) >= 0;
}
exports.find = find;
function indexOf(elements, needValue, needKey) {
    for (let i = 0, len = elements.length; i < len; i++)
        if (needKey in elements[i] && elements[i][needKey] === needValue)
            return i;
    return -1;
}
exports.indexOf = indexOf;
